<template>
    <div class="pt15">
        <div class="sub_title">
            교환정보
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tbody>
                <tr>
                    <td class="c_t_title">상태</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{ returnStatus() }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">교환요청일</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{ returnDateTimeFormat(orderData.requestDate) }}
                        </div>
                    </td>
                </tr>
                <tr >
                    <td class="c_t_title">필수 교환사유</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{orderData.reasonType}}
                        </div>
                    </td>
                </tr>
                <tr >
                    <td class="c_t_title">교환사유</td>
                    <td colspan="3">
                        <div class="d_block">
                            <el-input type="textarea" v-model="reason" rows="3" readonly
                                      resize="none"></el-input>
                        </div>
                    </td>
                </tr>
                <tr v-if="checkUserImage()">
                    <td class="c_t_title">첨부이미지</td>
                    <td colspan="3">
                        <div class="pt10 pb10">
<!--                            <div class="order_img" v-for="(img,index) in orderData.tradeImageFiles" :key="img.a_idx"-->
<!--                                 :style="`background-image:url(${img.org_url})`"  @click="showImage()" ></div>-->
                            <image-viewer-component  :photos="orderData.exchangeImageFiles"></image-viewer-component>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">반품 수령인명</td>
                    <td>
                        <div class="d_block">{{orderData.tradeName}}</div>
                    </td>
                    <td class="c_t_title">반품 수령인 전화번호</td>
                    <td>
                        <div class="d_block">{{orderData.tradeHp}}</div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">반품 수령인 주소</td>
                    <td colspan="3">
                        <div class="d_block search">
                            <el-input class="table_s_input mr10" v-model="tradeZipcode" ></el-input>
                            <el-button type="primary" @click="openDaumModal('trade')">우편번호 검색 ></el-button>
                            <el-input class="mt10" v-model="tradeAddress"></el-input>
                            <el-input class="mt10" v-model="tradeAddressDetail" @change="parentChange('tradeAddressDetail', tradeAddressDetail)"></el-input>
                            <div class="input_error">{{ validation.firstError('tradeZipcode') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">배송 요청 사항</td>
                    <td colspan="3">
                        <div class="d_block">{{getDeliveryReasonName(orderData.tradeDelivery)}}</div>
                    </td>
                </tr>
                <tr v-if="isShowReasonType(orderData.tradeDelivery)">
                    <td class="c_t_title">배송 메세지</td>
                    <td colspan="3">
                        <div class="d_block">
                            <el-input type="textarea" v-model="tradeDeliveryMemo" rows="3" @input="parentChange('tradeDeliveryMemo', tradeDeliveryMemo)"
                                      resize="none" placeholder="배송메시지를 입력해주세요."></el-input>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">교환 수령인명</td>
                    <td>
                        <div class="d_block">{{orderData.receiverName}}</div>
                    </td>
                    <td class="c_t_title">교환 수령인 전화번호</td>
                    <td>
                        <div class="d_block">{{orderData.receiverHp}}</div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">교환 수령인 주소</td>
                    <td colspan="3">
                        <div class="d_block search">
                            <el-input class="table_s_input mr10" v-model="receiverZipcode" ></el-input>
                            <el-button type="primary" @click="openDaumModal('receive')">우편번호 검색 ></el-button>
                            <el-input class="mt10" v-model="receiverAddress"></el-input>
                            <el-input class="mt10" v-model="receiverAddressDetail" @change="parentChange('receiverAddressDetail', receiverAddressDetail)"></el-input>
                            <div class="input_error">{{ validation.firstError('receiverZipcode') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">배송 요청 사항</td>
                    <td colspan="3">
                        <div class="d_block">{{getDeliveryReasonName(orderData.receiverDelivery)}}</div>
                    </td>
                </tr>
                <tr v-if="isShowReasonType(orderData.receiverDelivery)">
                    <td class="c_t_title">배송 메세지</td>
                    <td colspan="3">
                        <div class="d_block">
                            <el-input type="textarea" v-model="receiverDeliveryMemo" rows="3" @input="parentChange('receiverDeliveryMemo', receiverDeliveryMemo)"
                                      resize="none" placeholder="배송메시지를 입력해주세요."></el-input>
                        </div>
                    </td>
                </tr>
                <!--                승인일때-->
                <tr v-if="orderData.exchangeStatus == 1 || orderData.exchangeStatus == 3">
                    <td class="c_t_title">교환승인일</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{ returnDateTimeFormat(orderData.exchangeAcceptDate) }}
                        </div>
                    </td>
                </tr>
                <tr v-if="orderData.exchangeStatus == 1 || orderData.exchangeStatus == 3">
                    <td class="c_t_title">교환승인 추가 안내</td>
                    <td colspan="3">
                        <div class="d_block">
                            <div class="d_block">
                                <el-input type="textarea" v-model="adminReason" rows="3" @input="parentChange('adminReason', adminReason)" resize="none"></el-input>
                            </div>
                        </div>
                    </td>
                </tr>
                <!--                거절일때-->
                <tr v-if="orderData.exchangeStatus == 2">
                    <td class="c_t_title">교환거절일</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{ returnDateTimeFormat(orderData.exchangeRejectDate) }}
                        </div>
                    </td>
                </tr>
                <tr v-if="orderData.exchangeStatus == 2">
                    <td class="c_t_title">거절사유</td>
                    <td colspan="3">
                        <div class="d_block">
                            <div class="d_block">
                                <el-input type="textarea" v-model="adminReason" rows="3" @input="parentChange('adminReason', adminReason)"
                                          resize="none"></el-input>
                            </div>
                        </div>
                    </td>
                </tr>
                <!--                교환완료일때-->
                <tr v-if="orderData.exchangeStatus == 3">
                    <td class="c_t_title">교환완료일</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{ returnDateTimeFormat(orderData.exchangeCompleteDate) }}
                        </div>
                    </td>
                </tr>
                <!--                철회일때-->
                <tr v-if="orderData.exchangeStatus == 4">
                    <td class="c_t_title">교환철회일</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{ returnDateTimeFormat(orderData.rejectDate) }}
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";
import ImageViewerComponent from "@/components/image/ImageViewerComponent";
import dateMixins from "@/mixins/dateMixins";
import SimpleVueValidation from "simple-vue-validator";
import Vue from "vue";
const Validator = SimpleVueValidation.Validator;
import EventBus from "@/mixins/event-bus";
import orderMixins from "@/mixins/orderMixins";

Vue.use(SimpleVueValidation);
export default {
    name: "OrderExchangeLayout",
    mixins: [dateMixins, orderMixins],
    components: {
        ImageViewerComponent
    },
    inject: [],
    provide() {
        return {}
    },
    props: {
        setComponentData: {
            default: () => {
            }, type: Function
        },
        setValidatorArr: {
            default: () => {
            }, type: Function
        },
        setImportLayoutNames: {default: () => {}, type: Function},
        orderData: {
            default: () => {
            }, type: Object
        },
        orderClass: {default: null,},
    },
    data() {
        return {
            adminReason : '',
            reason : '',

            orderStatus : '',


            tradeZipcode:'',
            tradeAddress:'',
            tradeAddressDetail:'',
            tradeDeliveryMemo: '',
            receiverZipcode:'',
            receiverAddress:'',
            receiverAddressDetail:'',
            receiverDeliveryMemo: '',
            shippingMemo:'',
            validatorArr: [
                'adminReason',
                'tradeZipcode',
                'tradeAddress',
                'tradeAddressDetail',
                'receiverZipcode',
                'receiverAddress',
                'receiverAddressDetail',
            ],

            setAddressDataType: 'trade',

            deliveryReasonCategory: [],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.getDeliveryReasonCategory();
        this.initData()
    },
    mounted() {
        this.setValidatorArr(this.validatorArr);
        this.setImportLayoutNames('OrderExchangeLayout')
        EventBus.$on('setExchangeAddress', this.setAddress);
    },
    beforeDestroy() {
        EventBus.$off('setExchangeAddress')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        getDeliveryReasonCategory() {
            this.$api.$order.getDeliveryReasonCategory().then(res => res.Data.Result).then(res => {
                this.deliveryReasonCategory = res.List;
            })
        },
        initData(){
            if(!util.isEmpty(this.orderData)){
                this.reason = this.orderData.reason
                this.adminReason = this.orderData.adminReason
                this.orderStatus = this.orderData.orderStatus
                this.tradeZipcode = this.orderData.tradeZipcode;
                this.tradeAddress = this.orderData.tradeAddress;
                this.tradeAddressDetail = this.orderData.tradeAddressDetail;
                this.tradeDeliveryMemo = this.orderData.tradeDeliveryMemo;
                this.receiverZipcode = this.orderData.receiverZipcode;
                this.receiverAddress = this.orderData.receiverAddress;
                this.receiverAddressDetail = this.orderData.receiverAddressDetail;
                this.receiverDeliveryMemo = this.orderData.receiverDeliveryMemo;
            }
        },
        checkImage(){
            if(!util.isEmpty(this.orderData.itemFiles) && !util.isEmpty(this.orderData.itemFiles[0].a_idx)){
                return this.orderData.itemFiles[0].org_url
            }
        },
        returnStatus(){
            return this.returnExchangeStatus(this.orderData.exchangeStatus);
        },
        checkAdmin(){
            if(this.orderData.orderMember === this.orderData.tradeMember){
                return true
            }
        },
        parentChange(type, value) {
            this.setComponentData(type, value);
        },
        checkValidator() {
            this.$validate(['adminReason', 'tradeZipcode', 'receiverZipcode'])
        },
        checkUserImage(){
            if(!util.isEmpty(this.orderData) && !util.isEmpty(this.orderData.exchangeImageFiles)){
                return true
            }
        },
        getDeliveryReasonName(key) {
            if(util.isEmpty(this.deliveryReasonCategory)) {
                return '-'
            }
            let index = this.deliveryReasonCategory.findIndex(drc => drc.od_idx == key);
            return index > -1 ? this.deliveryReasonCategory[index].od_name : '-';
        },
        showImage(){
            EventBus.$emit('runShow')
        },
        openDaumModal(type='trade') {
            this.setAddressDataType = type;
            this.$modal.show('daum-postcode-modal', {afterSetDataName: 'setExchangeAddress'})
        },
        setAddress(addrObj) {
            if(this.setAddressDataType == 'trade') {
                this.tradeZipcode = addrObj.zonecode;
                this.tradeAddress = addrObj.roadAddress;
                this.tradeAddressDetail = ''
                this.parentChange('tradeZipcode', this.tradeZipcode);
                this.parentChange('tradeAddress', this.tradeAddress);
                this.parentChange('tradeAddressDetail', this.tradeAddressDetail);
            }else if(this.setAddressDataType == 'receive') {
                this.receiverZipcode = addrObj.zonecode;
                this.receiverAddress = addrObj.roadAddress;
                this.receiverAddressDetail = ''
                this.parentChange('receiverZipcode', this.receiverZipcode);
                this.parentChange('receiverAddress', this.receiverAddress);
                this.parentChange('receiverAddressDetail', this.receiverAddressDetail);

            }
        },
        isShowReasonType(type) {
            if(util.isEmpty(this.deliveryReasonCategory)) {
                return false;
            }
            let index = this.deliveryReasonCategory.findIndex(drc => drc.od_idx == type);
            if(index < 0) {
                return false;
            }
            return this.deliveryReasonCategory[index].od_is_text === 1;
        },
    },
    watch: {},
    validators: {
        adminReason: function (value) {
            return Validator.value(value)
        },
        tradeZipcode: function (value) {
            return Validator.value(value)
                .required('주소를 입력하세요.')
        },
        tradeAddress: function (value) {
            return Validator.value(value)
        },
        tradeAddressDetail: function (value) {
            return Validator.value(value)
        },
        receiverZipcode: function (value) {
            return Validator.value(value)
                .required('주소를 입력하세요.')
        },
        receiverAddress: function (value) {
            return Validator.value(value)
        },
        receiverAddressDetail: function (value) {
            return Validator.value(value)
        },
    }
}
</script>

<style scoped>

</style>
